const sockets = {};

export function registerDeskPlugin(slot, component) {
    sockets[slot] = component;
}

export function resolveDeskPlugin(slot) {
    return sockets[slot] ?? null;
}
